import { render, staticRenderFns } from "./add-anti-thesis.vue?vue&type=template&id=aa0a60e0&scoped=true&"
import script from "./add-anti-thesis.vue?vue&type=script&lang=js&"
export * from "./add-anti-thesis.vue?vue&type=script&lang=js&"
import style0 from "./add-anti-thesis.vue?vue&type=style&index=0&id=aa0a60e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa0a60e0",
  null
  
)

export default component.exports